<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th class="text-right">Total de operações</th>
        <th class="text-right">Quantidade total</th>
        <th class="text-right">Custo total</th>
        <th class="text-right">Valor total</th>
      </tr>
    </thead>

    <tbody class="grey lighten-2 font-weight-medium">
      <tr>
        <td class="text-right">
          {{ totalCountString }}
        </td>

        <td :class="['text-right', { 'error--text': overview.totalQuantity < 0 }]">
          {{ totalQuantityString }}
        </td>

        <td :class="['text-right', { 'error--text': overview.totalCosts < 0 }]">
          {{ totalCostsString }}
        </td>

        <td :class="['text-right', { 'error--text': overview.totalValue < 0 }]">
          {{ totalValueString }}
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { formatMoney, formatNumber } from '@/utils/format-utils';

export default {
  name: 'ShareOptionsOperationsOverview',

  props: {
    overview: {
      type: Object,
      required: true,
    },
  },

  computed: {
    totalCountString: (vm) => formatNumber(vm.overview.totalCount ?? 0),
    totalQuantityString: (vm) => formatNumber(vm.overview.totalQuantity ?? 0),
    totalCostsString: (vm) => formatMoney(vm.overview.totalCosts ?? 0),
    totalValueString: (vm) => formatMoney(vm.overview.totalValue ?? 0),
  },
};
</script>
